import { Routes } from "@angular/router";

export const PRICING_ROUTES = {
    TARIFARIO_SLI: {
        HOME: "tariff-logistic-home"
    },
    TARIFAS_ESPECIALES_SLI: {
        HOME: "special-tariff-logistic-home"
    }
}

export const PricingRoutes: Routes = [
    {
        path: PRICING_ROUTES.TARIFARIO_SLI.HOME,
        loadComponent: () => import("./tarifario-sli/presentacion/bandeja-tarifario-sli/bandeja-tarifario-sli.component").then(c => c.BandejaTarifarioSliComponent)
    },
    {
        path: PRICING_ROUTES.TARIFAS_ESPECIALES_SLI.HOME,
        loadComponent: () => import("./tarifa-especial-sli/presentacion/bandeja-tarifa-especial-sli/bandeja-tarifa-especial-sli.component").then(c => c.BandejaTarifaEspecialSliComponent)
    }
]